const ACTIONS = {
    TRIGGER_EDAP_EVENT: 'EDAP/TRIGGER_EDAP_EVENT',
    TRIGGER_EDAP_LISTING_BOOKNOW_CLICK: 'TRIGGER_EDAP_LISTING_BOOKNOW_CLICK',
    LOG_TEST_EXPOSURE: 'LOG_TEST_EXPOSURE',
    TRIGGER_EDAP_CHECKOUT_SELECTED: 'TRIGGER_EDAP_CHECKOUT_SELECTED',
    TRIGGER_EDAP_PROPERTY_SUMMARY_PRESENTED: 'TRIGGER_EDAP_PROPERTY_SUMMARY_PRESENTED',
    TRIGGER_EDAP_PRICE_QUOTE_PRESENTED: 'TRIGGER_EDAP_PRICE_QUOTE_PRESENTED',
    TRIGGER_EDAP_PROPERTY_DETAILS_MAP_PRESENTED: 'TRIGGER_EDAP_PROPERTY_DETAILS_MAP_PRESENTED',
    TRIGGER_EDAP_PROPERTY_DETAILS_PARTNER_INFORMATION_SELECTED:
        'TRIGGER_EDAP_PROPERTY_DETAILS_PARTNER_INFORMATION_SELECTED',
    TRIGGER_EDAP_UX_PROPERTY_DETAILS_NAVIGATION_SELECTED:
        'TRIGGER_EDAP_UX_PROPERTY_DETAILS_NAVIGATION_SELECTED',
    TRIGGER_EDAP_PROPERTY_DETAILS_DESCRIPTION_PRESENTED:
        'TRIGGER_EDAP_PROPERTY_DETAILS_DESCRIPTION_PRESENTED',
    TRIGGER_EDAP_PROPERTY_DETAILS_AMENITIES_DETAILS_SELECTED:
        'TRIGGER_EDAP_PROPERTY_DETAILS_AMENITIES_DETAILS_SELECTED',
    TRIGGER_EDAP_PROPERTY_INQUIRY_SELECTED: 'TRIGGER_EDAP_PROPERTY_INQUIRY_SELECTED',
    TRIGGER_EDAP_PROPERTY_DETAILS_REVIEWS_DETAILS_SELECTED:
        'TRIGGER_EDAP_PROPERTY_DETAILS_REVIEWS_DETAILS_SELECTED',
    TRIGGER_EDAP_PROPERTY_DETAILS_REVIEWS_PRESENTED:
        'TRIGGER_EDAP_PROPERTY_DETAILS_REVIEWS_PRESENTED',
    TRIGGER_EDAP_PROPERTY_DETAILS_AMENITIES_PRESENTED:
        'TRIGGER_EDAP_PROPERTY_DETAILS_AMENITIES_PRESENTED',
    TRIGGER_EDAP_PROPERTY_DETAILS_HOUSE_RULES_PRESENTED:
        'TRIGGER_EDAP_PROPERTY_DETAILS_HOUSE_RULES_PRESENTED',
    TRIGGER_EDAP_PROPERTY_DETAILS_DESCRIPTION_DETAILS_SELECTED:
        'TRIGGER_EDAP_PROPERTY_DETAILS_DESCRIPTION_DETAILS_SELECTED'
};

const ACTION_CREATORS = {
    triggerEdapEvent(eventName, eventData, options) {
        return {
            type: ACTIONS.TRIGGER_EDAP_EVENT,
            payload: {
                eventName,
                eventData,
                options
            }
        };
    },
    triggerEdapListingBooknowClick(actionLocation) {
        return {
            type: ACTIONS.TRIGGER_EDAP_LISTING_BOOKNOW_CLICK,
            payload: {
                actionLocation
            }
        };
    },
    triggerEdapCheckoutSelected() {
        return {
            type: ACTIONS.TRIGGER_EDAP_CHECKOUT_SELECTED,
            payload: {}
        };
    },

    triggerEdapPriceQuotePresented(data) {
        return {
            type: ACTIONS.TRIGGER_EDAP_PRICE_QUOTE_PRESENTED,
            payload: {data}
        };
    },

    triggerEdapPropertySummaryPresented() {
        return {
            type: ACTIONS.TRIGGER_EDAP_PROPERTY_SUMMARY_PRESENTED,
            payload: {}
        };
    },

    triggerEdapPropertyDetailsMapPresented() {
        return {
            type: ACTIONS.TRIGGER_EDAP_PROPERTY_DETAILS_MAP_PRESENTED,
            payload: {}
        };
    },

    triggerEdapPropertyDetailsDescriptionPresented() {
        return {
            type: ACTIONS.TRIGGER_EDAP_PROPERTY_DETAILS_DESCRIPTION_PRESENTED,
            payload: {}
        };
    },

    triggerEdapPropertyDetailsPartnerInformationDetailsSelected() {
        return {
            type: ACTIONS.TRIGGER_EDAP_PROPERTY_DETAILS_PARTNER_INFORMATION_SELECTED,
            payload: {}
        };
    },

    triggerEdapPropertyDetailsAmenitiesDetailsSelected() {
        return {
            type: ACTIONS.TRIGGER_EDAP_PROPERTY_DETAILS_AMENITIES_DETAILS_SELECTED,
            payload: {}
        };
    },

    triggerEdapUxPropertyDetailsNavigationSelected(tabName, actionLocation) {
        return {
            type: ACTIONS.TRIGGER_EDAP_UX_PROPERTY_DETAILS_NAVIGATION_SELECTED,
            payload: {tabName, actionLocation}
        };
    },

    triggerEdapPropertyInquirySelected(actionLocation) {
        return {
            type: ACTIONS.TRIGGER_EDAP_PROPERTY_INQUIRY_SELECTED,
            payload: {actionLocation}
        };
    },

    triggerEdapPropertyDetailsReviewsDetailsSelected() {
        return {
            type: ACTIONS.TRIGGER_EDAP_PROPERTY_DETAILS_REVIEWS_DETAILS_SELECTED,
            payload: {}
        };
    },

    triggerEdapPropertyDetailsReviewsPresented() {
        return {
            type: ACTIONS.TRIGGER_EDAP_PROPERTY_DETAILS_REVIEWS_PRESENTED,
            payload: {}
        };
    },

    triggerEdapPropertyDetailsAmenitiesPresented() {
        return {
            type: ACTIONS.TRIGGER_EDAP_PROPERTY_DETAILS_AMENITIES_PRESENTED,
            payload: {}
        };
    },

    triggerEdapPropertyDetailsHouseRulesPresented() {
        return {
            type: ACTIONS.TRIGGER_EDAP_PROPERTY_DETAILS_HOUSE_RULES_PRESENTED,
            payload: {}
        };
    },

    triggerEdapPropertyDetailsDescriptionDetailsSelected(descriptionType) {
        return {
            type: ACTIONS.TRIGGER_EDAP_PROPERTY_DETAILS_DESCRIPTION_DETAILS_SELECTED,
            payload: {descriptionType}
        };
    },

    logTestExposure(testName) {
        return {
            type: ACTIONS.LOG_TEST_EXPOSURE,
            payload: {
                testName
            }
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
